import { InvoiceModel, useCancelInvoiceMutation } from '@frontend/api-invoices';
import { useTranslation } from '@frontend/i18n';
import { Modal, ModalControlModalProps, useAlert } from '@frontend/design-system';

type InvoiceCancelModalProps = {
  modalProps: ModalControlModalProps;
  invoice: InvoiceModel | undefined;
  onClose: () => void;
  onCancel?: () => void;
};

export const InvoiceCancelModal = ({ modalProps, invoice, onClose, onCancel }: InvoiceCancelModalProps) => {
  const { t } = useTranslation('payments');
  const alert = useAlert();
  const { cancelInvoice } = useCancelInvoiceMutation({
    locationId: invoice?.locationId || '',
    onSuccess: () => {
      alert.success(t('Payment Request Canceled Successfully.'));
      onCancel?.();
    },
  });

  return (
    <Modal {...modalProps}>
      <Modal.Header>{t('Confirm Cancel Payment Request')}</Modal.Header>
      <Modal.Body>
        {t(
          'Canceling this request will delete it completely from your request reports. Do you still want to cancel this request?'
        )}
      </Modal.Body>
      <Modal.Footer
        primary={{
          type: 'button',
          destructive: true,
          onClick: () => {
            if (invoice) {
              cancelInvoice(invoice);
            }
            onClose();
          },
          label: t('Cancel Payment Request'),
        }}
        secondary={{
          onClick: onClose,
          label: t('Go Back'),
        }}
      />
    </Modal>
  );
};
